// extracted by mini-css-extract-plugin
export default {"fileWrapperContainer":"ImageInput_fileWrapperContainer__qBQh7"};